import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M15.9998 21C15.7438 21 15.4878 20.902 15.2928 20.707L7.29276 12.707C6.90176 12.316 6.90176 11.684 7.29276 11.293L15.2928 3.29301C15.6838 2.90201 16.3158 2.90201 16.7068 3.29301C17.0978 3.68401 17.0978 4.31601 16.7068 4.70701L9.41376 12L16.7068 19.293C17.0978 19.684 17.0978 20.316 16.7068 20.707C16.5118 20.902 16.2558 21 15.9998 21Z" />,
  'ChevronLeft'
);
